import Table from "../../../layouts/seller-hub/Table";

const History = () => {
  return (
    <Table>
      <div className="w-full md:w-1/2">
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Date time
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          12/07/2022 3:34pm
        </div>
      </div>
      <div className="w-full md:w-1/2">
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Detail
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Item created
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          edited
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          In cart
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Ordered
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Ordered
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Pending
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Ready for pickup
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Picked up
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          In transit
        </div>
        <div className="h-11 leading-[44px] border-b border-[#E9EAEC]">
          Delivered
        </div>
      </div>
    </Table>
  );
};

export default History;
